import { createAction, props } from '@ngrx/store';

import { CompaniesPageFilterState } from '@modules/companies/store/companies-page.reducer';
import { ApiParams, Company, Job, Manager } from '@shared';
import { Pagination } from '@shared/pagination';

/**
 * This is local module that main task is to handle pagination
 * and module specific actions. For other tasks use collection/companies
 */

export const companiesLoadPage = createAction(
  '[Companies List Page] Load Page',
  props<{ params?: ApiParams }>(),
);

export const companiesLoadPageAutoComplete = createAction(
  '[Companies List Page] Load Page AutoComplete',
  props<{ params?: ApiParams }>(),
);

export const companiesLoadPageSuccess = createAction(
  '[Companies List Page] Load Page Success',
  props<{ payload: Pagination<Company> }>(),
);

export const companiesLoadPageFail = createAction(
  '[Companies List Page] Load Page Fail',
  props<{ error: any }>(),
);

export const companiesPageSetFilter = createAction(
  '[Companies List Page] Set Filter',
  props<{ payload?: Partial<CompaniesPageFilterState> }>(),
);

export const companiesLoadJobsPerCompany = createAction(
  '[Companies List Page] Load Jobs For Company Page',
  props<{ companyId: number; params?: ApiParams }>(),
);

// data has to be passed via payload since that what pagination reducer expects
export const companiesLoadJobsPerCompanySuccess = createAction(
  '[Companies List Page] Load Jobs For Company Page Success',
  props<{ payload: Pagination<Job> }>(),
);

export const companiesLoadJobsPerCompanyFail = createAction(
  '[Companies List Page] Load Jobs For Company Page Fail',
  props<{ error: any }>(),
);

export const loadManagersPerCompany = createAction(
  '[Companies List Page] Load Managers Per Company',
  props<{ id: number; offset: number; filterText?: string }>(),
);

export const loadManagersPerCompanySuccess = createAction(
  '[Companies List Page] Load Managers Per Company Success',
  props<{ managersPerCompany: Pagination<Manager> }>(),
);

export const loadManagersPerCompanyFailure = createAction(
  '[Companies List Page] Load Managers Per Company Failure',
  props<{ error: any }>(),
);

export const updateManagerPerCompany = createAction(
  '[Companies List Page] Update Manager Per Company',
  props<{ manager: Manager }>(),
);

export const updateManagerPerCompanySuccess = createAction(
  '[Companies List Page] Update Manager Per Company Success',
  props<{ manager: Manager; companyId: number }>(),
);

export const updateManagerPerCompanyFail = createAction(
  '[Companies List Page] Update Manager Per Company Fail',
  props<{ error: any }>(),
);

export const createManagerPerCompany = createAction(
  '[Companies List Page] Create Manager Per Company',
  props<{ manager: Partial<Manager>; photo?: File }>(),
);

export const createManagerPerCompanySuccess = createAction(
  '[Companies List Page] Create Manager Per Company Success',
  props<{ manager: Manager; companyId: number }>(),
);

export const createManagerPerCompanyFail = createAction(
  '[Companies List Page] Create Manager Per Company Fail',
  props<{ error: any }>(),
);

export const createManagerPerCompanyWithPhoto = createAction(
  '[Companies List Page] Create Manager Per Company With Photo',
  props<{ manager: Manager }>(),
);
